<template>
  <div id="h-nav">
    <div class="container">
      <div class="side-nav">
        <i></i>全部商品分类
        <div class="side-ul-wrap" @mouseleave="hoverIndex=-1">


          <ul class="side-ul " :class="{fixed : isIndexPage}">
            <li v-for="(item,index) in categoryList" @mouseenter="hoverIndex = index">
              <router-link :to="{path:'/list',query:{cate1Id:item.id}}" @click.native="toChange">
                <div class="double-line">
                  <span class="real-img">
                    <span class="real-img-ab">
                      <img class="icon" src="../assets/side-icon1.png">
                      <img class="icon" src="../assets/side-icon1-h.png">
                    </span>
                  </span>
                  <span class="icon-text">{{ item.cateName }}</span>
                </div>
                <div class="double-line-b" v-if="item.children && item.id!=2018 && item.id!=2015 " >
                  <!--              <router-link :to="{path:'/list',query:{cateId:item.id}}" v-for="item in item.children.slice(0,2)">-->
                  <span v-for="item in item.children.slice(0,2)" >
                      {{ item.cateName }}
                  </span>
                  <!--              </router-link>-->
                </div>
                <div class="double-line-b" v-else-if="item.children && item.id==2015" >
                  <span>祥云系列等</span>
                </div>
                <div class="double-line-b" v-else-if="item.children && item.id==2018" >
                  <span>3、5、7系列 天智系列等</span>
                </div>
                <div class="double-line-b" v-else >
                  
                </div>
              </router-link>
            </li>
          </ul>

          <div class="nav-items" v-for="(item,index) in categoryList"

               @mouseenter="hoverIndex = index"
               :class="{on:hoverIndex == index}"

          >
            <!--							<i-nav-items ></i-nav-items>-->
            <i-nav-items :category-list="item.children"></i-nav-items>
          </div>


        </div>

      </div>
      <div class="main-nav">
        <ul class="fc">
          <li class="pdL20">
            <router-link to="index">
              首页
            </router-link>
          </li>
          <!--					<li>-->
          <!--						<router-link to="#">-->
          <!--							专业选型-->
          <!--						</router-link>-->
          <!--						<i class="op-icons op-icons-new"></i>-->
          <!--					</li>-->
          <li>
            <router-link to="list">
              产品选型
            </router-link>
          </li>
          <!--					<li>-->
          <!--						<router-link to="#">-->
          <!--							限时秒杀-->
          <!--						</router-link>-->

          <!--					</li>-->
          <li v-if="showCoupon || isIntegralUser">
            <router-link :to="isIntegralUser ? '/score' : '/coupons'">
              {{ isIntegralUser ? '积分商城' : '领劵中心' }}
            </router-link>
          </li>
<!--          <li @click="jifenFun">-->
<!--            <router-link to="#">-->
<!--              积分商城-->
<!--            </router-link>-->
<!--          </li>-->
          <!-- 暂时隐藏积分用户的订单入口，保留其他用户的我的订单 -->
          <li v-if="!isIntegralUser">
            <router-link :to="orderRoute">
              {{ isIntegralUser ? '积分订单' : '我的订单' }}
            </router-link>
          </li>
          <!--					<li>-->
          <!--						<router-link to="#">-->
          <!--							报价单-->
          <!--						</router-link>-->

          <!--					</li>-->
          <!--					<li>-->
          <!--						<router-link to="#">-->
          <!--							竞品替换-->
          <!--						</router-link>-->

          <!--					</li>-->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import currentUser from '@/mixins/current-user'
import {queryCategoryList} from "@/api/home";
import iNavItems from "@/components/i-nav-items";

export default {
  mixins: [currentUser],
  components: {iNavItems},
  name: 'head-nav-bar',
  props: {
    isIndexPage: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      categoryList: [],
      hoverIndex:-1
    }
  },
  mounted() {
    //缓存处理
    let sessCategorys = JSON.parse(sessionStorage.getItem('categorys'))
    if (sessCategorys && sessCategorys.length > 0) {
      this.categoryList = sessCategorys
    } else {
      this.queryCategoryListFun()
    }
    // this.queryCategoryListFun()
  },
  computed: {
    showCoupon () {
      return !this.isLoggedIn || Number(this.currentUser.dealerLevel) === 2
    },
    orderRoute () {
      return this.isIntegralUser ? '/integralOrders' : '/orders'
    }
  },
  methods: {
    toChange(){
      // this.$router.go(0);
    },
    queryCategoryListFun() {
      queryCategoryList().then(res => {
        console.log('查询分类', res)
        this.categoryList = res.categorys
        sessionStorage.setItem('categorys', JSON.stringify(res.categorys))
      })
    },
    jifenFun() {
      console.log('123123')
      alert("正在建设中")
    }
  },

}
</script>

<style scoped="scoped" lang="less">
.side-nav {
  cursor: pointer;
}
#h-nav .nav-items.on{
  display: block;
  top: 41px;
}
.side-nav i {
  width: 28px;
  height: 28px;
  background: url(../assets/goods-category.png) no-repeat;
  margin-right: 10px;
  margin-bottom: 5px;
}

#h-nav .side-nav:hover {
  .side-ul {
    display: block;
  }
}
</style>
